import { Dispatch, SetStateAction } from "react";
import { ImageLoadingState } from "../image-loading.enum";

export default (imageUrl: string, setImageLoadingState: Dispatch<SetStateAction<ImageLoadingState>>): void => {
    const newImg = new Image();

    newImg.onload = () => {
        setImageLoadingState(ImageLoadingState.LOADED);
    };

    newImg.onerror = () => {
        setImageLoadingState(ImageLoadingState.ERROR);
    };

    newImg.src = imageUrl;
};